import { cognitoUserInAnyGroup } from '@akin-home/auth/frontend';
import { CognitoUserGroup } from '@akin-home/aws-cognito';
import { useAuthState } from '../../auth-provider/AuthProvider';

interface Props {
  security_groups: CognitoUserGroup[];
  children?: React.ReactNode;
}

/**
 * This component hooks into the currently authenticated user and only renders the children
 * components if the current user is not in the security groups specified in props
 *
 * This can be useful for limiting unecessary information for admin or other users
 *
 * Its not as useful as AllowSecurityGroups, prefer that component where possible.
 */
export const ExcludeSecurityGroups = ({
  security_groups,
  children,
}: Props): React.ReactNode => {
  const { auth_user } = useAuthState();

  if (!auth_user || !children) return null;

  if (!cognitoUserInAnyGroup(security_groups)(auth_user)) {
    return children;
  }

  return null;
};
